import React, { useState, useEffect } from 'react';
import '../../CSS/Global.css';
import './Events.css';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSidebar } from '../../SidebarContext';
import Sidebar from '../SideBar';
import AddEventModal from './AddEventModal';
import EditEventModal from './EditEventModal';

const Events = () => {
    const { isSidebarOpen } = useSidebar();
    const [events, setEvents] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingEvent, setEditingEvent] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 8;

    const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";
    const BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL || process.env.REACT_APP_LINK || '';

    useEffect(() => {
        fetchEvents();
    }, []);

    const fetchEvents = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/events/admin/all/${isLoggedIn.user_id}`);
            setEvents(response.data || []);
        } catch (error) {
            console.error('Error fetching events:', error);
            toast.error('Error fetching events');
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Are you sure you want to delete this event?')) return;
        try {
            const response = await axios.delete(`${BASE_URL}/events/${id}`);
            if (response.status === 200) {
                toast.success('Event deleted successfully');
                fetchEvents();
            }
        } catch (error) {
            toast.error('Error deleting event');
        }
    };

    const handleEventAdded = () => {
        fetchEvents();
        setIsModalOpen(false);
    };

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const totalPages = Math.ceil(events.length / itemsPerPage);
    const currentData = events.slice(indexOfFirstItem, indexOfFirstItem + itemsPerPage);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const getImageUrl = (img) => {
        if (!img) return null;
        if (String(img).startsWith('http')) return img;
        const str = String(img).replace(/\\/g, '/');
        const base = (BASE_URL || '').replace(/\/+$/, '');
        return base ? `${base}/${str}` : null;
    };

    const getEventImages = (evt) => {
        let imgs = evt?.images;
        if (!imgs) return [];
        if (typeof imgs === 'string') {
            try { imgs = JSON.parse(imgs); } catch { return []; }
        }
        return Array.isArray(imgs) ? imgs : [];
    };

    const handleEventUpdated = () => {
        fetchEvents();
        setEditingEvent(null);
    };

    return (
        <>
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">Events</h1>
                    <button className="oms-add-btn" onClick={() => setIsModalOpen(true)}>
                        Add Event
                    </button>
                </div>

                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Title</th>
                                <th>Short Description</th>
                                <th>Images</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData && currentData.length > 0 ? (
                                currentData.map((evt) => (
                                    <tr key={evt.id}>
                                        <td>{evt.date}</td>
                                        <td>{evt.title}</td>
                                        <td className="event-desc-cell">{(evt.shortDescription || '').slice(0, 80)}{(evt.shortDescription || '').length > 80 ? '...' : ''}</td>
                                        <td>
                                            {(() => {
                                                const imgs = getEventImages(evt);
                                                return imgs.length > 0 ? (
                                                    <div className="event-thumb-list">
                                                        {imgs.slice(0, 3).map((img, i) => (
                                                            <img key={i} src={getImageUrl(img)} alt="" className="event-thumb" />
                                                        ))}
                                                        {imgs.length > 3 && <span>+{imgs.length - 3}</span>}
                                                    </div>
                                                ) : (
                                                    <span className="no-images">-</span>
                                                );
                                            })()}
                                        </td>
                                        <td>
                                            <button onClick={() => setEditingEvent(evt)} title="Edit">
                                                <i className="fa fa-edit" />
                                            </button>
                                            <button onClick={() => handleDelete(evt.id)} title="Delete">
                                                <i className="fa fa-trash" />
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5">No events yet. Add your first event!</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {totalPages > 1 && (
                    <div className="pagination">
                        <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                            <i className="fa-solid fa-chevron-left"></i><i className="fa-solid fa-chevron-left"></i>
                        </button>
                        <button className="active">{currentPage}</button>
                        {currentPage < totalPages && (
                            <button onClick={() => paginate(currentPage + 1)}>{currentPage + 1}</button>
                        )}
                        {currentPage + 1 < totalPages && <span className="dots">...</span>}
                        {currentPage !== totalPages && (
                            <button onClick={() => paginate(totalPages)}>{totalPages}</button>
                        )}
                        <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                            <i className="fa-solid fa-chevron-right"></i><i className="fa-solid fa-chevron-right"></i>
                        </button>
                    </div>
                )}
            </div>

            <AddEventModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onSuccess={handleEventAdded}
                isLoggedIn={isLoggedIn}
            />
            <EditEventModal
                isOpen={!!editingEvent}
                onClose={() => setEditingEvent(null)}
                onSuccess={handleEventUpdated}
                eventData={editingEvent}
                isLoggedIn={isLoggedIn}
            />
        </>
    );
};

export default Events;
